import { render } from "./ServicesNew.vue?vue&type=template&id=59bc54ab&scoped=true&ts=true"
import script from "./ServicesNew.vue?vue&type=script&lang=ts"
export * from "./ServicesNew.vue?vue&type=script&lang=ts"

import "./ServicesNew.vue?vue&type=style&index=0&id=59bc54ab&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bc54ab"]])

export default __exports__